import { TypographyP } from '@talentmesh/ui/components/typography';
import React from 'react';
import { ChipCloud } from '../components';
import { JobAdSkill, JobAdSkillType } from '../Models/JobAdSkill';
import UIStrings from '../utils/UIStrings';

interface SkillsCardProps {
    skills: JobAdSkill[];
}

function SkillsCard({ skills }: SkillsCardProps): React.JSX.Element {
    const getSkillNames = (skillType: JobAdSkillType) => {
        return skills.filter((item) => item.skillType === skillType).map((item) => item.skillName);
    };
    const hasHardSkills = skills.some((item) => item.skillType === 'HardSkill');
    const hasSoftSkills = skills.some((item) => item.skillType === 'SoftSkill');

    return (
        <section className="border-border bg-muted/50 flex flex-col gap-4 rounded-lg border p-5">
            <TypographyP className="text-base font-bold">{UIStrings.SkillsThatMakeYouSucceedInThisRole}</TypographyP>
            {hasHardSkills && <ChipCloud chips={getSkillNames('HardSkill')} label={`${UIStrings.HardSkills}:`} />}
            {hasSoftSkills && (
                <ChipCloud chips={getSkillNames('SoftSkill')} label={`${UIStrings.SoftSkillsAndPersonality}:`} />
            )}
        </section>
    );
}

export default SkillsCard;
